// Initials fallback (e.g. 'Martijn' -> 'M', 'Placeholder One' -> 'PO')
function initials(name = '') {
  return name.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase()
}

function Avatar({ review }) {
  const base = { width: 42, height: 42, borderRadius: '50%', flexShrink: 0, objectFit: 'cover' }
  if (review.photo) {
    return <img src={`${process.env.PUBLIC_URL}/reviews/${review.photo}`} alt={review.name} style={base} />
  }
  // Warm gold-toned initials — this is a human moment, the one place gold lives.
  return (
    <div aria-hidden="true" style={{
      ...base,
      background: 'rgba(219,160,90,0.16)', color: 'var(--color-text)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 600,
      border: '1px solid rgba(219,160,90,0.5)',
    }}>
      {initials(review.name)}
    </div>
  )
}

export default function ReviewCard({ review }) {
  return (
    <div style={{
      background: 'var(--color-background)',           // warm paper, not white
      border: '1px solid var(--color-rule)',           // hairline map-rule
      borderRadius: 'var(--radius-lg)',
      padding: '24px',
    }}>
      {/* gold star row */}
      {review.rating ? (
        <div style={{ color: 'var(--color-accent-warm)', fontSize: '13px', marginBottom: '12px', letterSpacing: '2px' }}>
          {'★'.repeat(review.rating)}
        </div>
      ) : null}

      {/* quote — gold opening quote-mark accent */}
      <p style={{ fontSize: '15px', lineHeight: 1.65, color: 'var(--color-text)', marginBottom: '16px' }}>
        <span style={{ fontFamily: 'var(--font-heading)', color: 'var(--color-accent-warm)', fontSize: '22px', lineHeight: 0, verticalAlign: '-4px', marginRight: '2px' }}>“</span>
        {review.text}
      </p>

      {/* gold hairline accent */}
      <div style={{ height: '2px', width: '32px', background: 'var(--color-accent-warm)', marginBottom: '14px' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Avatar review={review} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 600 }}>{review.name}</div>
          {/* country · trek · date — slate mono, reads as proof */}
          <div className="data" style={{ fontSize: '11px', color: 'var(--color-accent-cool)', marginTop: '3px' }}>
            {review.country}
            {review.trek ? ` · ${review.trek}` : ''}
            {review.date ? ` · ${review.date}` : ''}
          </div>
          {review.source && (
            <div style={{ fontSize: '10px', color: 'var(--color-text-secondary)', marginTop: '4px', letterSpacing: '0.3px' }}>
              ✓ Verified on {review.source}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
